import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NewMapsDialogViewComponent } from '../new-maps-dialog-view/new-maps-dialog-view.component';
import { Iaddress } from 'my-lib-sanfelici';

@Component({
  selector: 'app-new-maps-dialog',
  templateUrl: './new-maps-dialog.component.html',
  styleUrls: ['./new-maps-dialog.component.scss']
})
export class NewMapsDialogComponent implements OnInit {
  @Input() address: Iaddress;


  constructor(public dialog: MatDialog) { }
  openDialog(): void {
    const dialogRef = this.dialog.open(NewMapsDialogViewComponent, {
data: {address: this.address}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.address = result;
      console.log('The dialog was closed');
      console.log(this.address);
    });

  }

  ngOnInit() {
  }

}
